const CaseFileDeclined = {
    No: 0,
    Yes: 1,
    DeclinedInternalFile: 2,
    DeclinationDocument: 3,
    DeclinationDocumentApproved: 4,
    ExtendDaysApproved: 5,
    ExtendDaysDeclined: 6,
    ExtendDateDocumentInActive: 7,
    ExtendDaysDocumentActive: 8,
    ExtendedDaysApprovedSent: 9,
    ExtendedDaysDeclinedSent: 10,
    CaseFileIsPending: 11,
    ReuploadedFile: 12,
    ReuploadedFileAccepted: 13,
    ReuploadedFileDeclined: 14,
    FileIsCorrect: 15,
    PreviouslyDeclinedFile: 16,
    RequireCaseCancellation: 17,
    CaseCancellationDocument: 18,
    CaseCancellationDocumentDeclined: 19,
    CaseCancellationDocumentDeclinedSent: 20,
    RewriteDocument: 21,
    RewriteDocumentResponeded: 22,
    isConditionalFile: 23,
    ConditionalFileAct: 24,
    ConditionalFileActSent: 25,
    ExpertDoc: 26,
    ExpertDocSent: 27,
    RequireCaseCancellationBuilding: 28,
    RequireCaseCancellationBuildingAnswer: 29,
    RequireCaseCancellationBuildingAnswerDenied: 30,
    explosionFile: 31,
    acceptRemoveFromRegistery: 32,
    declineRemoveFromRegistery: 33,
    secretDocument: 34
}
export default CaseFileDeclined